import * as C from '../constants';

export default {
  /**
   * @param commit
   * @param breadcrumbs
   */
  setBreadcrumbs({ commit }, breadcrumbs) {
    commit(C.NAV_SET_BREADCRUMBS, breadcrumbs);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/actions.js